import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SessionInitService } from '@core/services/session-init.service';
import { UiOrganismGlobalSpinnerComponent } from '@shared/components/organisms/ui-organism-global-spinner/ui-organism-global-spinner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, UiOrganismGlobalSpinnerComponent],
  template: `
    <router-outlet></router-outlet>
    <app-ui-organism-global-spinner></app-ui-organism-global-spinner>
  `,
})
export class App {
  // Servicio de traducción compartido en toda la aplicación
  private readonly translate = inject(TranslateService);

  // Servicio de inicialización de sesión
  private readonly sessionInit = inject(SessionInitService);

  constructor() {
    const saved = localStorage.getItem('lang') as 'en' | 'uk' | null;
    const initial = saved ?? 'en';

    // Registramos los idiomas soportados
    this.translate.addLangs(['en', 'uk']);

    // Idioma inicial de la aplicación
    this.translate.use(initial);

    // Inicializar sistema de sesión (auto-logout después de 24h)
    this.sessionInit.initialize();
  }
}
